'use client';

import { FC, useEffect, useRef, useState } from 'react';
import { useTranslations } from 'next-intl';
import styles from './AboutSection.module.scss';
export interface AboutSectionProps {
  title?: string;
  description: string;
  maxLines?: number;
}
const AboutSection: FC<AboutSectionProps> = ({
  title,
  description,
  maxLines = 4
}) => {
  const t = useTranslations('workspace-details');
  const [expanded, setExpanded] = useState(false);
  const pRef = useRef<HTMLParagraphElement>(null);
  const [lineCount, setLineCount] = useState(0);
  useEffect(() => {
    if (!pRef.current) return;
    const el = pRef.current;
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    if (!lineHeight) return;
    const lines = Math.round(el.scrollHeight / lineHeight);
    setLineCount(lines);
  }, [description]);
  if (!description) return null;
  return <section className={styles.section} data-sentry-component="AboutSection" data-sentry-source-file="AboutSection.tsx">
            <h2 className={styles.heading}>{title || t('about')}</h2>
            <p ref={pRef} className={`${styles.text} ${expanded ? styles.expanded : ''}`} style={{
      WebkitLineClamp: expanded ? 'unset' : maxLines
    }}>
                {description}
            </p>
            {description.length > 200 && lineCount > maxLines && <button type="button" className={styles.toggle} onClick={() => setExpanded(!expanded)}>
                    {expanded ? t('showLess') : t('readMore')}
                </button>}
        </section>;
};
export default AboutSection;